// Generated share names — the memorable default title for a new share.
//
// Purity contract: `generateShareName` is a pure function of its injected
// RNG. It touches no DOM, no network, no clock; with a seeded RNG the
// output sequence is fully deterministic (see share-names.test.ts). The
// default RNG is `Math.random`.
//
// Format: `adjective-noun-NN` (e.g. `quiet-harbor-42`) — lowercase kebab,
// exactly two words plus a zero-padded two-digit suffix, matching the
// spec's `/^[a-z]+-[a-z]+-\d{2,3}$/` with exactly two digits generated.
// The wordlists (171 adjectives × 148 nouns × 100 suffixes ≈ 2.5M
// combinations) keep real-world collisions negligible per the spec's
// uniqueness criterion.

/** Lowercase single-word adjectives; all distinct. */
export const SHARE_NAME_ADJECTIVES: readonly string[] = [
  "amber",
  "ancient",
  "arctic",
  "auburn",
  "austere",
  "avid",
  "azure",
  "balmy",
  "bashful",
  "bitter",
  "bland",
  "bold",
  "bouncy",
  "brave",
  "brisk",
  "broad",
  "calm",
  "candid",
  "chalky",
  "charming",
  "cheeky",
  "cheerful",
  "chill",
  "civil",
  "classy",
  "clean",
  "clear",
  "clever",
  "coastal",
  "comfy",
  "cool",
  "cosmic",
  "crisp",
  "curious",
  "dainty",
  "daring",
  "dapper",
  "dazzling",
  "deep",
  "deft",
  "dewy",
  "dim",
  "dreamy",
  "dry",
  "dusky",
  "dusty",
  "eager",
  "early",
  "earnest",
  "easy",
  "ebony",
  "edgy",
  "electric",
  "elegant",
  "elfin",
  "empty",
  "endless",
  "epic",
  "ethereal",
  "faint",
  "fair",
  "fast",
  "feisty",
  "festive",
  "fine",
  "fleet",
  "fluent",
  "foggy",
  "fond",
  "frank",
  "fresh",
  "friendly",
  "frisky",
  "frosted",
  "full",
  "gentle",
  "giddy",
  "glad",
  "glossy",
  "golden",
  "grand",
  "grassy",
  "gray",
  "great",
  "gusty",
  "handy",
  "happy",
  "hardy",
  "hazy",
  "hearty",
  "hidden",
  "hollow",
  "honest",
  "humble",
  "hushed",
  "icy",
  "ideal",
  "jaded",
  "jaunty",
  "jolly",
  "jovial",
  "keen",
  "kind",
  "kindly",
  "late",
  "lazy",
  "leafy",
  "lean",
  "limber",
  "limpid",
  "lithe",
  "lively",
  "lonely",
  "lucid",
  "lush",
  "mellow",
  "merry",
  "mighty",
  "mild",
  "misty",
  "modest",
  "level",
  "nimble",
  "noble",
  "north",
  "open",
  "opal",
  "petal",
  "plush",
  "prim",
  "proud",
  "quiet",
  "radiant",
  "rapid",
  "rested",
  "rich",
  "rosy",
  "rustic",
  "serene",
  "shy",
  "silken",
  "sleek",
  "snug",
  "soft",
  "solid",
  "sparkly",
  "spicy",
  "spry",
  "steely",
  "sunny",
  "sure",
  "sweet",
  "swift",
  "tender",
  "thawed",
  "tidy",
  "timely",
  "true",
  "unhurried",
  "upbeat",
  "vernal",
  "vivid",
  "warm",
  "wavy",
  "willing",
  "winsome",
  "wise",
  "witty",
  "wooden",
  "wooly",
  "zesty",
];

/** Lowercase single-word nouns; all distinct. */
export const SHARE_NAME_NOUNS: readonly string[] = [
  "anchor",
  "anemone",
  "apple",
  "arbor",
  "atlas",
  "aurora",
  "bamboo",
  "banner",
  "basin",
  "beacon",
  "beetle",
  "bison",
  "bloom",
  "blossom",
  "bobcat",
  "boulder",
  "branch",
  "breeze",
  "bridge",
  "brook",
  "bubble",
  "bucket",
  "buffalo",
  "button",
  "cabin",
  "cactus",
  "cameo",
  "canyon",
  "cargo",
  "cedar",
  "chapel",
  "chasm",
  "chestnut",
  "chorus",
  "cliff",
  "clover",
  "comet",
  "compass",
  "copper",
  "coral",
  "cotton",
  "cougar",
  "coyote",
  "cricket",
  "current",
  "daisy",
  "delta",
  "denim",
  "dinghy",
  "dolphin",
  "drift",
  "eagle",
  "ember",
  "fable",
  "falcon",
  "fathom",
  "feather",
  "fern",
  "fjord",
  "flint",
  "flora",
  "forest",
  "fossil",
  "foxglove",
  "galaxy",
  "garden",
  "geyser",
  "ginger",
  "glacier",
  "glade",
  "gorge",
  "granite",
  "grove",
  "grotto",
  "harbor",
  "harness",
  "hazel",
  "heron",
  "hollow",
  "honey",
  "horizon",
  "island",
  "ivory",
  "jasmine",
  "juniper",
  "kettle",
  "lagoon",
  "lantern",
  "larch",
  "lilac",
  "lotus",
  "lynx",
  "magnolia",
  "maple",
  "marble",
  "marigold",
  "meadow",
  "mesa",
  "mosaic",
  "moss",
  "mountain",
  "nebula",
  "nectar",
  "nimbus",
  "oasis",
  "obsidian",
  "ocean",
  "orchid",
  "osprey",
  "otter",
  "paddle",
  "pebble",
  "pewter",
  "pigeon",
  "pinnacle",
  "plateau",
  "prairie",
  "quartz",
  "raven",
  "reef",
  "ridge",
  "river",
  "robin",
  "ruby",
  "saffron",
  "sage",
  "sapphire",
  "sequoia",
  "shadow",
  "shale",
  "shore",
  "silver",
  "sparrow",
  "spruce",
  "starling",
  "summit",
  "sunset",
  "thicket",
  "thunder",
  "timber",
  "topaz",
  "tundra",
  "urchin",
  "velvet",
  "violet",
  "walnut",
  "willow",
  "zephyr",
];

/**
 * Draw a share name: `adjective-noun-NN` (e.g. `quiet-harbor-42`). The
 * `rng` must return uniform floats in [0, 1) — `Math.random` by default;
 * tests inject a seeded PRNG for reproducible sequences.
 */
export function generateShareName(rng: () => number = Math.random): string {
  const adjective =
    SHARE_NAME_ADJECTIVES[pickIndex(rng, SHARE_NAME_ADJECTIVES.length)];
  const noun = SHARE_NAME_NOUNS[pickIndex(rng, SHARE_NAME_NOUNS.length)];
  const number = String(pickIndex(rng, 100)).padStart(2, "0");
  return `${adjective}-${noun}-${number}`;
}

/** Uniform integer in [0, length) from one rng draw. */
function pickIndex(rng: () => number, length: number): number {
  return Math.floor(rng() * length);
}
